import React, { useMemo } from "react";
import CareProfileStoryShareSheet from "../../components/Dashboard/shared/CareProfileStoryShareSheet";
import {
  buildProfileShareSections,
  buildProfileShareSummary,
} from "./profileShareSummary";
import { useProfileShareTimeline } from "./useProfileShareTimeline";

const UnifiedProfileShareFlow = ({
  open,
  onClose,
  childId,
  personName,
  age,
  preferredLanguage,
  selectedConditions,
  chapters,
  medications,
  providers,
  foodAllergies,
  dietaryRestrictions,
  documents,
  canViewDocuments,
}) => {
  const timeline = useProfileShareTimeline({ childId });
  const baseSections = useMemo(() => buildProfileShareSections({
    personName,
    age,
    preferredLanguage,
    selectedConditions,
    chapters,
    medications,
    providers,
    foodAllergies,
    dietaryRestrictions,
    documents,
    canViewDocuments,
  }), [
    age,
    canViewDocuments,
    chapters,
    dietaryRestrictions,
    documents,
    foodAllergies,
    medications,
    personName,
    preferredLanguage,
    providers,
    selectedConditions,
  ]);
  const sections = useMemo(() => [
    ...baseSections,
    {
      id: "timeline",
      title: "Recent Timeline activity",
      lines: timeline.lines,
      hasContent: true,
      defaultSelected: false,
    },
  ], [baseSections, timeline.lines]);

  const buildSharePayload = (selections) => {
    const summarySections = sections.map((section) => (
      section.id === "timeline"
        ? {
          ...section,
          lines: timeline.lines.length
            ? timeline.lines
            : [`No Timeline activity matched ${timeline.periodLabel}.`],
        }
        : section
    ));
    return buildProfileShareSummary({
      personName,
      sections: summarySections,
      selections,
    });
  };

  return (
    <CareProfileStoryShareSheet
      open={open}
      onClose={onClose}
      sections={sections}
      buildSharePayload={buildSharePayload}
      timelineControls={timeline}
      title={`Share ${personName}'s care summary`}
    />
  );
};

export default UnifiedProfileShareFlow;
